import { nativeEnum, object, date } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Allowed_List_Phone_Number_Time_Period } from '@occc/graphql';

export const allowListPhoneNumberFilterValidationSchema = object({
  period: nativeEnum(Allowed_List_Phone_Number_Time_Period, { message: IS_REQUIRED }),
  startDate: date({ message: IS_REQUIRED }).optional(),
  endDate: date({ message: IS_REQUIRED }).optional(),
})
  .refine(
    (data) => {
      if (data.period === Allowed_List_Phone_Number_Time_Period.Custom) {
        return !!data.startDate;
      }

      return true;
    },
    {
      message: IS_REQUIRED,
      path: ['startDate'],
    },
  )
  .refine(
    (data) => {
      if (data.period === Allowed_List_Phone_Number_Time_Period.Custom) {
        return !!data.endDate;
      }

      return true;
    },
    {
      message: IS_REQUIRED,
      path: ['endDate'],
    },
  );

export const AllowListPhoneNumberFilterValidation = makeValidate(
  allowListPhoneNumberFilterValidationSchema,
);

export const isAValidDate = (value: unknown): value is Date => {
  if (!value) {
    return false;
  }

  if (typeof value === 'number' || typeof value === 'string' || value instanceof Date) {
    return date().safeParse(new Date(value)).success;
  }

  return false;
};
